<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">
      <div data-v-3e52ce59="" class="loading" v-if="loading">
        <div data-v-3e52ce59="" class="loader"><span data-v-3e52ce59="" class="load-img"></span></div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      daoTime: null,
      loading: false,
    };
  },
  created() {
    let that = this;
    console.log('版本代码更新时间 2022-09-21 17:58');

    var query = that.$route.query;

    if (query.pid) {
      localStorage.setItem('pid', query.pid);

      if(that.$route.path == '/'){
        return;
      }
      that.$router.push({ path: '/?pid=' + query.pid });

    }
    that.getVisitUrl();
    that.getApp();

    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
  },
  methods: {
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          // "ios_download_qrcode": "http://mb2.tg-demo.cc:86/uploads/images/e13177382b3e958789c877f71b034ca9.jpg",
          // "ios_download_url": "http://mb2.tg-demo.cc:86/",
          // "h5_url": "http://mb2m.tg-demo.cc"
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    getVisitUrl() {
      let that = this;
      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            if (process.env.NODE_ENV == 'development') {
              //开发环境
              return;
            }

            let url = that.pid ? res.data.url + '?pid=' + that.pid : res.data.url;
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
                userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeDaoTime();
            that.$router.push({ path: '/' });
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 3300);
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getUserInfoShowLoding() {
      let that = this;
      that.showLoading();
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
        that.hideLoading();
      });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    goNav(url) {
      let that = this;
      if (url == '/userredpacket') {
        if (!that.$store.state.token) {
          that.showTost(0, '请登录！');
          return;
        }

        if (that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
        let routerData = this.$router.resolve({
          path: `/userredpacket`,
        });
        window.open(routerData.href, '_blank');

        return;
      }
      if (url == this.$route.fullPath) {
        if (url == '/') {
          return;
        }
        that.showTost(0, '已在当前页面！');
        return;
      }
      this.url = url;
      if (url == '/accountSetting') {
        if (!sessionStorage.getItem('token')) {
          $('.mask').fadeOut(300);
          $('.mask.login').fadeIn(300);
          return;
        }
      }
      this.$router.push({ path: url });
    },
    openKefu() {
      let that = this;
      that.showTost(1, '正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url);
        }
      });
    },

    showTost(type, title) {
      // error  success
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div role="alert" class="ants-message el-message el-message--${str}" style="top: 20px; z-index: 2009;"><i class="el-message__icon el-icon-${str}"></i>
            <p class="el-message__content">${title}
            </p></div>`);
      setTimeout('$(".ants-message").detach()', 2000);
    },
  },
  mounted() {},
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
.swiper-pagination-bullet-active {
  background-color: #ffcb4c;
  border-radius: 6px;
}
.swiper-pagination-bullet {
  width: 0.1rem;
  height: 0.1rem;
  background-color: #ffcb4c;
}

.myAccount .nav ul li.active .icon,
.myAccount .nav ul li.active,
.myAccount .nav ul li:hover .icon,
.myAccount .nav ul li:hover {
  color: #ffcb4c;
}

.el-pagination {
  background: none;
  color: #ffcb4c;
}
.el-pager li.active {
  color: #ffcb4c !important;
  border: 1px solid #ffcb4c;
  border-radius: 0.01rem;
  cursor: default;
}
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 28px;
  color: #ffcb4c;
}

.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 0.28rem;
  color: #ffcb4c;
}
.el-pagination button:disabled {
  color: #ffcb4c;
  background: none;
}
.el-pager li {
  background: none;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background: none;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #ffcb4c;
}

element.style {
}
*,
body,
h1,
h2,
h3,
h4,
h5,
p,
ul {
  padding: 0;
  margin: 0;
}
* {
  margin: 0;
  padding: 0;
}
user agent stylesheet :not(svg) {
  transform-origin: 0px 0px;
}
.el-radio-button:first-child .el-radio-button__inner {
  background: none;
}
.el-radio-button:last-child .el-radio-button__inner {
  background: none;
}
.popInputGroups .el-input__inner,
.el-input__inner input {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue